import * as actionTypes from '../actions/types';

const initialState = {
    interestedInYou: [],
    messages: [],
    errors: null
}

const messageReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.ADD_INTERESTED_IN_YOU:
            return state;

        case actionTypes.SHOW_INTERESTED_IN_YOU:
            return {...state, interestedInYou: action.payload};

        case actionTypes.FETCH_MESSAGE_ROOM_MESSAGES:
            return {...state, messages: action.payload};

        case actionTypes.UNMATCH_COUPLE:
            return {...state, interestedInYou: action.payload};

        case actionTypes.MESSAGE_SENT:
            return state;

        default:
            return state;
    }
}

export default messageReducer;